/* The lengths script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO web: the live packages page script, 2026-09-17 capture. Two edits only: short ids, and figures of 1,000 and over carry a separator. */

(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoLengths) return;
  root.dataset.xgoLengths = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO  = 'IntersectionObserver' in window;
  var SENS   = { yes: 'Yes', opt: 'Optional', na: 'Not fitted' };
  /* ---------- the lengths: framed tabs over one render; the plan under it redraws to the length ----------
     Each tab carries its share of the tray (data-len-l) and the length it draws (data-len-mm). Without JS the first panel
     that is not hidden shows, with its render, so nothing is lost. */
  [].forEach.call(root.querySelectorAll('[data-len]'), function (box) {
    var tabs = [].slice.call(box.querySelectorAll('[data-len-t]'));
    var imgs = [].slice.call(box.querySelectorAll('[data-len-img]'));
    var plan = box.querySelector('[data-len-plan]'), fig = box.querySelector('[data-len-fig]');
    function pick(t, focus) {
      var k = t.getAttribute('data-len-t');
      tabs.forEach(function (b) {
        var on = b === t, p = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (p) p.hidden = !on;
      });
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-len-img') === k); });
      if (plan) plan.style.setProperty('--l', t.getAttribute('data-len-l'));
      if (fig) fig.textContent = t.getAttribute('data-len-mm');
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var j = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (j === undefined) return;
        e.preventDefault();
        pick(tabs[(j + tabs.length) % tabs.length], true);
      });
    });
  });

})();
